// Interface for the module object structure
interface ModuleItem {
  id: number;
  code: string;
  displayName: string;
  pmEnabled: boolean;
}

// Array of module data
const moduleData: ModuleItem[] = [
  {
    id: 6003,
    code: "Clinical Advances & Conference Updates",
    displayName: "Clinical Updates",
    pmEnabled: false
  },
  {
    id: 6001,
    code: "Clinical Guidelines & Protocols",
    displayName: "Guidelines & Protocols",
    pmEnabled: false
  },
  {
    id: 6004,
    code: "Educational Resources",
    displayName: "Skill Building",
    pmEnabled: false
  },
  {
    id: 6005,
    code: "Expert Insights & Opinion",
    displayName: "Expert Insights",
    pmEnabled: false
  },
  {
    id: 6002,
    code: "Patient Case Studies & Real-world Evidence",
    displayName: "Case Studies & Evidence",
    pmEnabled: false
  },
  {
    id: 6006,
    code: "Patient Communication Resources",
    displayName: "Patient Communication",
    pmEnabled: false
  },
  {
    id: 6007,
    code: "Podcasts & Audio Learning",
    displayName: "Podcasts",
    pmEnabled: false
  }
];

/**
 * Get display name from code name
 * @param codeName - The code name to search for
 * @returns The display name if found, otherwise the original code name
 */
export const getDisplayNameFromCode = (codeName: string): string => {
  const module = moduleData.find(item => item.code === codeName);
  return module ? module.displayName : codeName;
};

/**
 * Get display name from ID
 * @param id - The ID to search for
 * @returns The display name if found, otherwise empty string
 */
export const getDisplayNameFromId = (id: number): string => {
  const module = moduleData.find(item => item.id === id);
  return module ? module.displayName : "";
};

/**
 * Get code name from ID
 * @param id - The ID to search for
 * @returns The code name if found, otherwise empty string
 */
export const getCodeNameFromId = (id: number): string => {
  const module = moduleData.find(item => item.id === id);
  return module ? module.code : "";
};

/**
 * Get all module data
 * @returns Array of all module items
 */
export const getAllModuleData = (): ModuleItem[] => {
  return moduleData;
};
